import { render, staticRenderFns } from "./OwnersDocs.vue?vue&type=template&id=11a99e73&scoped=true&"
import script from "./OwnersDocs.vue?vue&type=script&lang=js&"
export * from "./OwnersDocs.vue?vue&type=script&lang=js&"
import style0 from "./OwnersDocs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OwnersDocs.vue?vue&type=style&index=1&id=11a99e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a99e73",
  null
  
)

export default component.exports